/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaoBaoSkuVo } from './TaoBaoSkuVo';
import {
    TaoBaoSkuVoFromJSON,
    TaoBaoSkuVoFromJSONTyped,
    TaoBaoSkuVoToJSON,
    TaoBaoSkuVoToJSONTyped,
} from './TaoBaoSkuVo';
import type { ItemImageVo } from './ItemImageVo';
import {
    ItemImageVoFromJSON,
    ItemImageVoFromJSONTyped,
    ItemImageVoToJSON,
    ItemImageVoToJSONTyped,
} from './ItemImageVo';

/**
 * 
 * @export
 * @interface TaoBaoProductVo
 */
export interface TaoBaoProductVo {
    /**
     * 
     * @type {Array<ItemImageVo>}
     * @memberof TaoBaoProductVo
     */
    itemImgs?: Array<ItemImageVo>;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoProductVo
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof TaoBaoProductVo
     */
    totalPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof TaoBaoProductVo
     */
    totalNum?: number;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoProductVo
     */
    picUrl?: string;
    /**
     * 
     * @type {Array<TaoBaoSkuVo>}
     * @memberof TaoBaoProductVo
     */
    skus?: Array<TaoBaoSkuVo>;
}

/**
 * Check if a given object implements the TaoBaoProductVo interface.
 */
export function instanceOfTaoBaoProductVo(value: object): value is TaoBaoProductVo {
    return true;
}

export function TaoBaoProductVoFromJSON(json: any): TaoBaoProductVo {
    return TaoBaoProductVoFromJSONTyped(json, false);
}

export function TaoBaoProductVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaoBaoProductVo {
    if (json == null) {
        return json;
    }
    return {
        
        'itemImgs': json['itemImgs'] == null ? undefined : ((json['itemImgs'] as Array<any>).map(ItemImageVoFromJSON)),
        'title': json['title'] == null ? undefined : json['title'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'totalNum': json['totalNum'] == null ? undefined : json['totalNum'],
        'picUrl': json['picUrl'] == null ? undefined : json['picUrl'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(TaoBaoSkuVoFromJSON)),
    };
}

export function TaoBaoProductVoToJSON(json: any): TaoBaoProductVo {
    return TaoBaoProductVoToJSONTyped(json, false);
}

export function TaoBaoProductVoToJSONTyped(value?: TaoBaoProductVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'itemImgs': value['itemImgs'] == null ? undefined : ((value['itemImgs'] as Array<any>).map(ItemImageVoToJSON)),
        'title': value['title'],
        'totalPrice': value['totalPrice'],
        'totalNum': value['totalNum'],
        'picUrl': value['picUrl'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(TaoBaoSkuVoToJSON)),
    };
}

